// import img from "../constants/img";
export function onErrorImageOrg(e: any, imgOrg: string) {
    if (imgOrg) {
        e.target.src = imgOrg
            ? imgOrg
            : "https://dev.myspa.vn/assets/img/no-img.jpg";
    }
}
